import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { parseJwt } from '../utils/parseJwt';
import useAuth from '../hooks/useAuth';
import { hasSystemModule } from '../config/systemModules';
import { temAcessoAssinaturas, temAcessoFinanceiro, temAcessoPrestacao, temGestaoEscolar } from '../utils/roles';

// gestaoEscolar: exige a flag de gestão escolar quando a sessão é de exxer.
// assinaturas: exige a flag `assinaturas` quando a sessão é de exxer.
// prestacao: 'colaborador' ou 'financeiro' (Prestação de Contas), lido de usuario.prestacao_contas (/me).
const RoleRoute = ({ allowed, moduleKey, gestaoEscolar = false, assinaturas = false, prestacao = null }) => {
  const { usuario } = useAuth();
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');

  if (!token) return <Navigate to="/login" />;

  const payload = parseJwt(token);
  const usuarioAtual = usuario || payload;
  const tipoUsuario = usuarioAtual?.tipo_usuario;

  if (!allowed.includes(tipoUsuario)) return <Navigate to="/home" />;
  if (gestaoEscolar && tipoUsuario === 'exxer' && !temGestaoEscolar(usuarioAtual)) return <Navigate to="/home" />;
  if (assinaturas && !temAcessoAssinaturas(usuarioAtual)) return <Navigate to="/home" />;
  if (prestacao === 'colaborador' && !temAcessoPrestacao(usuarioAtual)) return <Navigate to="/home" />;
  if (prestacao === 'financeiro' && !temAcessoFinanceiro(usuarioAtual)) return <Navigate to="/home" />;
  if (Array.isArray(moduleKey)) {
    if (!moduleKey.some((key) => hasSystemModule(usuarioAtual, key))) return <Navigate to="/home" />;
  } else if (!hasSystemModule(usuarioAtual, moduleKey)) {
    return <Navigate to="/home" />;
  }

  return <Outlet />;
};

export default RoleRoute;
